import '../scss/main.scss';
import SimpleLightbox from 'simplelightbox'
import 'simplelightbox/dist/simple-lightbox.css';

window.addEventListener( 'DOMContentLoaded', () => {
	const containers = document.querySelectorAll('.image-gallery-container');

	containers.forEach(container => {
		new SimpleLightbox('#' + container.id + ' a');
	});
});